module.exports = __webpack_public_path__ + "static/videos/litho_005.b5b9a79.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/litho/litho_005.mp4
// module id = 474
// module chunks = 1